import toast from "react-hot-toast";
import { axiosInstance } from "../lib/axios";
import Cookies from 'js-cookie';

export const getGalleryImage = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/gallery/all?${params.toString()}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            }
        )
        return res.data.data
        // console.log("lorem")

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const registerGalleryPage = async (form, id) => {
    try {

        let data = { ...form, id };

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.post(
            `/gallery/register`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const getGalleryPage = async () => {
    try {

        const res = await axiosInstance.get(`/gallery/page`)
        console.log("gallery page response", res)
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const deleteGalleryImage = async (id) => {
    try {
        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/gallery/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const getGalleryByID = async (id) => {

    try {
        const res = await axiosInstance.get(`/gallery/${id}`)
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}
export const getGalleryImageByID = async (sectionId, id) => {

    try {
        const res = await axiosInstance.get(`/gallery/${sectionId}/${id}`)
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const registerImage = async (form, id, sectionId) => {
    try {
        const {
            image, isFeatured, order
        } = form;

        const formData = new FormData();

        if (id)
            formData.append("id", id);
        if (sectionId)
            formData.append("sectionId", sectionId);
        if (isFeatured)
            formData.append("isFeatured", isFeatured);
        if (order)
            formData.append("order", order);
        if (image) {
            formData.append("imageLink", image);
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/gallery/register/image`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const deleteImageFormGallery = async (sectionId, id) => {
    try {
        if (!id) {
            toast.error("id is not present");
        }
        if (!sectionId) {
            toast.error("Section id is required");
        }

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/gallery/${sectionId}/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}
